import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-bc3bbc88"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home"
};
const _hoisted_2 = {
  key: 0,
  class: "list"
};
import { onMounted, ref, nextTick } from 'vue';
import { ElLoading } from 'element-plus';
import { invoke } from '@tauri-apps/api';
import { ElMessageBox } from 'element-plus';
export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {
    const textarea = ref('');
    const isResize = ref(true);
    let res;
    const columns = ref([{
      key: 'origin',
      dataKey: 'origin',
      title: '原文',
      width: 150
    }, {
      key: 'target',
      dataKey: 'target',
      title: '译文',
      width: 150
    }]);
    const data = ref([{
      origin: '1',
      target: '2'
    }]);
    const clickTransfer = async () => {
      data.value = [];
      let current = textarea.value;
      execTransfer(current);
    };
    const clickResize = async () => {
      isResize.value = false;
      columns.value = [{
        key: 'origin',
        dataKey: 'origin',
        title: '原文',
        width: 200
      }, {
        key: 'target',
        dataKey: 'target',
        title: '译文',
        width: document.documentElement.clientWidth - 200
      }];
      nextTick(() => {
        isResize.value = true;
      });
    };
    const clickNode = async e => {
      // console.log(e.target.innerHTML);
      open(e.target.innerHTML);
    };
    const open = text => {
      text = text.replaceAll('\n', '<br/>');
      ElMessageBox.alert(text, '译文', {
        dangerouslyUseHTMLString: true
      });
    };
    function execTransfer(current) {
      current = current.replaceAll(' ', '');
      let juziList = [];
      current.split('།').forEach(v => {
        v.split('\n').forEach(v => v && juziList.push(v));
      });
      console.log(juziList);
      const {
        length
      } = juziList;
      for (let i = 0; i < length; i++) {
        const juzi = juziList[i];
        let danciList = juzi.split('་').filter(v => !!v);
        // 以单词为单位最长匹配
        for (let j = danciList.length; j > 0;) {
          const danci = danciList.slice(0, j).join('་');
          if (res[danci]) {
            data.value.push({
              origin: danci,
              target: res[danci]
            });
            danciList = danciList.slice(j);
            j = danciList.length;
          } else if (j === 1) {
            data.value.push({
              origin: danci,
              target: '未找到...'
            });
            danciList = danciList.slice(j);
            j = danciList.length;
          } else {
            j--;
          }
        }
      }
    }
    onMounted(async () => {
      const loading = ElLoading.service({
        lock: true,
        text: '词库加载中...'
      });
      res = await (await fetch('/fenci.json')).json();
      loading.close();
      invoke('greet', {
        name: 'World'
      })
      // `invoke` 返回异步函数
      .then(response => console.log('1' + response));
      columns.value = [{
        key: 'origin',
        dataKey: 'origin',
        title: '原文',
        width: 200
      }, {
        key: 'target',
        dataKey: 'target',
        title: '译文',
        width: document.documentElement.clientWidth - 200
      }];
      // document.addEventListener('resize', e => {
      //   location.reload();
      // reloadList.value = false;
      // columns.value = [
      //   {
      //     key: 'origin',
      //     dataKey: 'origin',
      //     title: '原文',
      //     width: 200,
      //   },
      //   {
      //     key: 'target',
      //     dataKey: 'target',
      //     title: '译文',
      //     width: document.documentElement.clientWidth - 200,
      //   },
      // ];
      // setTimeout(() => {
      //   reloadList.value = true;
      // }, 1000);
      // });
    });

    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_table_v2 = _resolveComponent("el-table-v2");
      const _component_el_auto_resizer = _resolveComponent("el-auto-resizer");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createElementVNode("textarea", {
        class: "input",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => textarea.value = $event),
        type: "textarea",
        placeholder: "Please input"
      }, null, 512), [[_vModelText, textarea.value]]), _createVNode(_component_el_button, {
        onClick: clickTransfer
      }, {
        default: _withCtx(() => [_createTextVNode("转换")]),
        _: 1
      }), _createVNode(_component_el_button, {
        onClick: clickResize
      }, {
        default: _withCtx(() => [_createTextVNode("宽度适应")]),
        _: 1
      }), isResize.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_el_auto_resizer, null, {
        default: _withCtx(({
          height,
          width
        }) => [_createVNode(_component_el_table_v2, {
          columns: columns.value,
          data: data.value,
          width: width,
          height: height,
          fixed: "",
          onClick: clickNode
        }, null, 8, ["columns", "data", "width", "height"])]),
        _: 1
      })])) : _createCommentVNode("", true)]);
    };
  }
});